import { ListStyle, Pointer } from '@yleisradio/areena-types';
import { Card } from 'components/Card';
import { useCards } from 'hooks/useCards';
import { useProgress } from 'hooks/useProgress';
import React from 'react';
import { getCardKey, getHistoryElapsedForCard } from 'utils/card';
import { Observable as ImpressionObservable } from 'contexts/ImpressionAnalyticsContext/Observable';
import { AnalyticsContextProvider } from 'contexts/AnalyticsContext';
import { idFromPointer } from 'utils/pointer';
import { GroupEngagementData } from 'components/SnowplowEngagementAnalytics/types';
import { PlaceholderCard } from 'components/PlaceholderCard';

type Props = {
  cardImageSizes: string;
  groupEngagementData: GroupEngagementData;
  hidden?: boolean;
  listStyle: ListStyle | undefined;
  pageIndex: number;
  pageKey: string;
  pageSize: number;
  source: Pointer;
  totalCount: number;
};

export const CardPage: React.FunctionComponent<Props> = ({
  cardImageSizes,
  groupEngagementData,
  hidden,
  listStyle,
  pageIndex,
  pageKey,
  pageSize,
  source,
  totalCount,
}) => {
  const { cards, loading, meta } = useCards({
    source,
    pageIndex,
    pageSize,
  });

  const { historyEntries } = useProgress(cards);

  return (
    <AnalyticsContextProvider context={meta?.analytics?.context?.comscore}>
      {cards.map((card, index) => {
        const cardKey = getCardKey(card, pageKey);
        const itemIndex = pageIndex * pageSize + index;

        return (
          <li
            key={cardKey}
            aria-posinset={itemIndex + 1}
            aria-setsize={totalCount}
            hidden={hidden}
          >
            <ImpressionObservable
              yleId={idFromPointer(card.pointer) || undefined}
              itemPosition={itemIndex}
            >
              <Card
                card={card}
                cardKey={cardKey}
                groupEngagementData={groupEngagementData}
                index={itemIndex}
                listStyle={listStyle}
                sizes={cardImageSizes}
                historyElapsed={getHistoryElapsedForCard(card, historyEntries)}
              />
            </ImpressionObservable>
          </li>
        );
      })}

      {loading &&
        Array.from({ length: pageSize }, (_, i) => (
          <li key={i} aria-hidden hidden={hidden}>
            <PlaceholderCard listStyle={listStyle} />
          </li>
        ))}
    </AnalyticsContextProvider>
  );
};
